import { GraphQLClient } from 'graphql-request'

const endpoint =
  import.meta.env.VITE_GRAPHQL_ENDPOINT ||
  'https://dev-zma-api.passiontech.xyz/graphql'

export const graphqlClient = new GraphQLClient(endpoint, {
  headers: {
    'Content-Type': 'application/json',
  },
})

// Function to update headers (e.g., for authentication)
export const updateGraphQLClientHeaders = (headers: Record<string, string>) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Object.assign(graphqlClient.requestConfig.headers, headers)
}

// Function to set authorization token
export const setAuthToken = (token: string) => {
  updateGraphQLClientHeaders({
    Authorization: `Bearer ${token}`,
  })
}

// Function to remove authorization token
export const removeAuthToken = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  delete graphqlClient.requestConfig.headers?.Authorization
}
